module.exports = __webpack_public_path__ + "img/006.e247a14e.jpg";